import { render } from "./IconLocationOn.vue?vue&type=template&id=3128d660"
import script from "./IconLocationOn.vue?vue&type=script&lang=js"
export * from "./IconLocationOn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__